const COUNTRY_LABELS = {
  de: [
    { coordinates: [3.15, 50.55], name: 'Frankreich' },
    { coordinates: [5.15, 51.75], name: 'Niederlande' },
    { coordinates: [6.35, 50.85], name: 'Deutschland' },
    { coordinates: [6.1, 49.85], name: 'Luxemburg' },
    { coordinates: [5.2, 50.55], name: 'Wallonien' },
  ],
  en: [
    { coordinates: [3.15, 50.55], name: 'France' },
    { coordinates: [5.15, 51.75], name: 'Netherlands' },
    { coordinates: [6.35, 50.85], name: 'Germany' },
    { coordinates: [6.1, 49.85], name: 'Luxembourg' },
    { coordinates: [5.2, 50.55], name: 'Wallonia' },
  ],
  fr: [
    { coordinates: [3.15, 50.55], name: 'France' },
    { coordinates: [5.15, 51.75], name: 'Pays-Bas' },
    { coordinates: [6.35, 50.85], name: 'Allemagne' },
    { coordinates: [6.1, 49.85], name: 'Luxembourg' },
    { coordinates: [5.2, 50.55], name: 'Wallonie' },
  ],
  nl: [
    { coordinates: [3.15, 50.55], name: 'Frankrijk' },
    { coordinates: [5.15, 51.75], name: 'Nederland' },
    { coordinates: [6.35, 50.85], name: 'Duitsland' },
    { coordinates: [6.1, 49.85], name: 'Luxemburg' },
    { coordinates: [5.2, 50.55], name: 'Wallonie' },
  ],
};

export default COUNTRY_LABELS;